import React, { Suspense } from 'react';

import type { Props as CircleMarkerProps } from './CircleMarker.ui';

const CircleMarkerUI = React.lazy(() => import('./CircleMarker.ui'));

export const CircleMarker: React.FunctionComponent<CircleMarkerProps> = ({ children, ...props }) => {
  return (
    <Suspense fallback="Loading (CircleMarker)">
      <CircleMarkerUI {...props}>{children}</CircleMarkerUI>
    </Suspense>
  );
};
